<template>
  <div class="com-box" :style="{height: isEdit ? null : pagesHeight}">
    <div class="front" :class="{'active-front': isEdit}" >
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0" @click="delCmp">删除</div>
        </div>
        <div class="head-right" @click="edit">编辑</div>
      </div>
      <preview-question />
    </div>
    <div class="back" :class="{'active-back': isEdit}">
      <question v-model="value" :isHasSignUp="isHasSignUp" ref="question" />
      <div style="height: 60px;"></div>
      <div class="footer">
        <div class="footer-item call" @click="cancel">取消</div>
        <div class="footer-item" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import previewQuestion from '@/pages/activity-home/components/question'
import question from '../../components/new-question'
import _ from 'loadsh'
export default {
  components: {
    previewQuestion,
    question
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean,
    isHasSignUp: Boolean
  },
  computed: {
     // 是否编辑
    isEditActivity() {
      return this.$route.query.from == 'manager' ? true : false
    }
  },
  data() {
    return {
      isEdit: false,
      formData: {},
      pagesHeight: '680px',
    }
  },
  methods: {
    async edit() {
      this.isEdit = true
      this.$emit('handle',['question',false])
    },
    cancel() {
      this.$refs.question.questionInit()
      this.isEdit = false
      this.$emit('handle', ['question',true])
    },
    async save() {
      this.$refs.question.onFailed().then(res => {
        this.isEdit = false
        this.$emit('handle', ['question',true])
      })
      
    },
    onFailed(activityId) {
      return this.$refs.question.onFailed(activityId)
    },
    init(activityId) {
      return this.$refs.question.onFailed(activityId)
    },
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }
  }
}
</script>

<style lang="stylus" scoped>
.com-box {
  position: relative;
  perspective: 800px;
  overflow hidden
  box-sizing: border-box;
  .front {
    position: absolute;
    left: 0;
    right: 0;
    transition: 1s;
    z-index: 1;
    backface-visibility: hidden;
    .head {
      box-sizing: border-box;
      position: absolute;
      top: 20px;
      left: 10px;
      width: 95%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
  .back {
    transform: rotateY(-180deg);
    backface-visibility: hidden;
    transition: 1s;
    margin-top: -10px;
    background: #fff;
    .footer {
      display: flex;
      justify-content center;
      width: 100%;
      padding: 10px 0;
    }
    .footer-item {
      color: #FFFFFF;
      padding: 10px 26px;
      border-radius: 4px;
      background: #FF6B31;
      margin-left: 20px;
    }
    .call {
      color: #FF6B31;
      background: #F4F4F4;
    }
  }
  .active-front {
    transform: rotateY(180deg);
  }
  .active-back {
    transform: rotateY(0deg);
  }
}
  
</style>